<template>
  <div class="seomain">
    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list-xs" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-top-xs">
              <el-row :gutter="40"  type="flex" justify="space-between">
                  <el-col :span="12">
                    <el-row :gutter="40"  >
                        <el-col :span="24">
                            <div class="t-tit-xs-up st-list-left">SKU:{{ v.sku }}</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="t-tit-xs-down st-list-left">SKU:{{ v.sku }}</div>
                        </el-col>
                    </el-row>
                  </el-col>
                <!-- <el-col :span="12">
                    <div class="t-tit-xs st-list-left">SKU:{{ v.sku }}</div>
                </el-col> -->
                <el-col :span="12">
                    <div class="t-tit-xs st-list-right">{{'待发货'}}</div>
                </el-col>
              </el-row>            
          </div>
          <div class="st-list-main">
            <p>订单类型：{{ '销售订单'}}</p>
            <p>提单人{{ '张三' }}</p>
            <p>销售员{{ '李四' }}</p>
            <p>订单数理：{{'123' }}</p>
            <p>客户：{{'123' }}</p>
            <p>收件人{{ '王五' }}</p>
            <p>收货电话{{ '189' }}</p>
            <p>收货地址{{ 'XXXXX' }}</p>
          </div>
          <div class="st-list-bottom-xs">
              <el-row :gutter="40"  type="flex" justify="space-between">
                <el-col :span="12" >
                    <div class="t-tit-xs st-list-left">SKU:{{ v.sku }}</div>
                </el-col>
                <el-col :span="12">
                    <div class="t-tit-xs st-list-right">{{'200台'}}</div>
                </el-col>
              </el-row>            
          </div>
          <div class="st-list-bottom-xs">
              <el-row :gutter="40"  type="flex" justify="space-between">
                <el-col :span="12" >
                    <div class="t-tit-xs st-list-left">SKU:{{ v.sku }}</div>
                </el-col>
                <el-col :span="12">
                    <div class="t-tit-xs st-list-right">{{'100台'}}</div>
                </el-col>
              </el-row>            
          </div>
          <div class="st-up-btn">
              <el-butten @click="uploadImage" class="t-tit-xs">上传发货照片</el-butten>
          </div>
          <div class="">
              <el-image :src="'https://t7.baidu.com/it/u=2604797219,1573897854&fm=193&f=GIF'"></el-image>
          </div>
          <div class="">
              <el-image :src="'https://t7.baidu.com/it/u=2604797219,1573897854&fm=193&f=GIF'"></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      stlist: [
          {
              sku:"PC-2022-05-21",
              total:"100",
              inventory_code:"100",
              product_name:"名称",
              brand:"名称",
              model:"model",
              amount:"12345",
          }
      ],
     
    };
  },
  watch: {},
  computed: {},
  methods: {
    // get_st_info: function() {
    //   let paramsid = this.$route.params.id;
    //   this.$post(this.$api.stGetXiaoshouInfo, { id: paramsid }).then((res) => {
    //     this.stlist = res.data;
    //     this.stinfo = res.data;
    //   });
    // },
    // uploadImage(){
    //     // alert(123)
    //     // console.log( window)
    //     window.h5sdk.ready(function() {
    //      window.tt.chooseImage({
    //         sourceType: ['album', 'camera'], // PC端无效
    //         count: 10,
    //         sizeType:['compressed'],
    //         cameraDevice: 'front',
    //         success (res) {
    //             console.log(res.tempFilePaths, res.tempFiles);
    //         },
    //         fail (res) {
    //             console.log(`chooseImage 调用失败`);
    //         }
    //     });
    //     });
    // }
  },

  uploadImage: function () {
    // tt.chooseImage({
    //   sourceType: ['album', 'camera'],
    //   count: 9,
    //   cameraDevice: "front",
    //   success: res => {
    //     console.log(JSON.stringify(res))
    //     this.setData({
    //       imageList: res.tempFilePaths
    //     })
    //   },
    //   fail(res) {
    //     console.log(JSON.stringify(res))
    //   }
    // })
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "订单详情"+Math.random()});
    });
  },
  created() {
    // this.get_st_info();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "订单详情22" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tab-content .st-list-xs {
  margin-bottom: 10px;
  background: #fff;
}
.st-list-top-xs {
  background: #51596E;
  text-align: center;
}
.st-list-bottom-xs{
    background: #8496AE;
    margin-top: 10px;
}
.t-tit-xs {
  color: #fff;
  line-height: 2.6;
}
.t-tit-xs-up {
  color: #fff;
  line-height: 1.6;
}
.t-tit-xs-down {
  color: greenyellow;
  line-height: 1;
  font-size: 10px;
}

.st-list-main {
  padding: 10px 15px;
}
.st-list-left {
  text-align: left;
  margin-left: 20px;
}
.st-list-right {
  text-align: right;
  margin-right: 20px;
}
.st-up-btn{
    background: #2A82E4;
    margin: 10px 20px;
    text-align: center;
    border-radius:5px;
}
</style>
